module.exports = __webpack_public_path__ + "static/media/purple.9a4d3d63.jpg";